import React from 'react';
import LoginErrorPlaceHolder from './LoginErrorPlaceHolder';
import HomeButton from './HomeButton';

const NotFoundPlaceHolder = () => (
  <LoginErrorPlaceHolder error={{ message: 'panel.not.found', translation: { on: true } }}>
    <HomeButton />
  </LoginErrorPlaceHolder>
);

export default NotFoundPlaceHolder;
